var V=Object.defineProperty;var z=(b,n,e)=>n in b?V(b,n,{enumerable:!0,configurable:!0,writable:!0,value:e}):b[n]=e;var _=(b,n,e)=>z(b,typeof n!="symbol"?n+"":n,e);import{LitElement as D,css as A,html as d,unsafeHTML as x}from"https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js";import"./uwp.selling-plan-selector.DQfa4VMG.js";import"./uwp.product-swatches.CiiJcndH.js";import"./uwp.currency.ZSKpVHj0.js";class C extends D{constructor(){var e;super();_(this,"fetchProduct",e=>fetch(`/products/${e}.js`).then(t=>t.json()).then(t=>(this.product=t,this.selectedVariant=t.variants[0],t)));this.currency=window.Shopify.currency.active||"USD",this.language=window.Shopify.locale||"en-US",this.moneyFormatter=new Intl.NumberFormat(this.language,{style:"currency",currency:this.currency,minimumFractionDigits:2,maximumFractionDigits:2}),this.debug=(e=window==null?void 0:window.Shopify)==null?void 0:e.designMode,this.variantChanged=!1,this.rules=[],this.rule=null,this.quantity=1,this.showDetailsHover=!1}async connectedCallback(){super.connectedCallback(),this.log("Mounted",{label:this.activatorLabel,content:this.subscriptionTooltipText}),this.productHandle&&(this.loading=!0,this.fetchProduct(this.productHandle)),this.bindFormEvents(),this.bindCartEvents(),this.rules=await this.fetchRules(),await this.getRule()}radioTemplate(){return d`
      <div class="skio-radio__container">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="1"
          ></circle>
          <circle
            class="skio-radio"
            cx="12"
            cy="12"
            r="7"
            fill="currentColor"
          ></circle>
        </svg>
      </div>
    `}sellingPlanDropdown(e){return d`
      <select
        class="selling-plan-dropdown ${this.getAvailableSellingPlans(e).length==1?"selling-plan-dropdown--one":""}"
        @change=${t=>{this.selectSellingPlan(t.target.value)}}
      >
        ${e?this.getAvailableSellingPlans(e).map(t=>d`
                <option
                  ?selected=${e.selected_selling_plan.id===t.id}
                  value=${t.id}
                >
                  ${t.name}
                </option>
              `):""}
      </select>
    `}sellingPlanButtons(e){return d`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        ${e?this.getAvailableSellingPlans(e).map(t=>d`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${t}"
                  id="selling_plan_button-${t.id}"
                  @change="${i=>this.selectSellingPlan(t.id)}"
                  ?checked=${e.selected_selling_plan===t}
                />

                <label for="selling_plan_button-${t.id}">
                  ${t.name}
                </label>
              `):""}
      </fieldset>
    `}invalidIcon(){return d`
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="#D22B2B"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    `}validIcon(){return d`
      <svg
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="#0BDA51"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    `}setupMode(){return d`
      <div class="setupMode">
        Skio Plan Picker
        <small>This will not appear on the live site.</small>

        <small>Key: ${this.key}</small>

        <div class="detection">
          ${this.product?this.validIcon():this.invalidIcon()} Product
        </div>

        <div class="detection">
          ${this.selectedVariant?this.validIcon():this.invalidIcon()}
          Selected Variant
        </div>

        <div class="detection">
          ${this.form?this.validIcon():this.invalidIcon()} Form
        </div>

        <div class="detection">
          ${this.variantInput?this.validIcon():this.invalidIcon()} Variant
          Input
        </div>

        <div class="detection">
          ${this.variantChanged?this.validIcon():this.invalidIcon()} Variant
          Change Detection
          <small>Please attempt to change the selected variant.</small>
        </div>

        <small
          >If any of these don't pass please troubleshoot using our
          <a
            target="_blank"
            rel="noreferrer"
            href="https://integrate.skio.com/troubleshooting"
            >troubleshooting guide</a
          >.</small
        >
      </div>
    `}groupContent(e){var t,i,s,o,l;return d`
      <div
        class="group-content ${((t=this.options)==null?void 0:t.layout)=="horizontal"?"":(i=this.options)!=null&&i.show_radio_selector&&((s=this.options)==null?void 0:s.dropdownPosition)=="inside"?"margin-left":""}"
      >
        <span class="selling-plan-dropdown-label"
          >${this.additionalFrequencyLabel()}</span
        >
        ${((o=this.options)==null?void 0:o.selector_type)=="dropdown"?this.sellingPlanDropdown(e):""}

        <!-- TODO: Make the label have the border instead of the group -->
        ${((l=this.options)==null?void 0:l.selector_type)=="button"?this.sellingPlanButtons(e):""}
        ${this.additionalContentText()}
      </div>
    `}renderDrawerContent(){const e=document.createElement("div");return e.innerHTML=this.subscriptionTooltipText,e.classList.add("rte"),this.subscriptionTooltipText!=="false"?d`${e}`:d`
          <ul>
            <li>
              <div class="skio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Get exclusive deals</p>
                <small>Subscribe for unique discounts</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Edit your subscription anytime</p>
                <small>Edit products, delivery schedule and more</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div class="skio-content">
                <p>No commitment</p>
                <small>Easy to cancel if it’s not for you</small>
              </div>
            </li>
          </ul>
        `}showDetails(){return d`
      <details
        class="skio-details"
        @mouseover=${e=>this.detailsMouseover()}
        @mouseleave=${e=>this.detailsMouseleave()}
      >
        <summary>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ai ai-ArrowRepeat"
            >
              <path d="M18 2l3 3-3 3" />
              <path d="M6 22l-3-3 3-3" />
              <path d="M21 5H10a7 7 0 0 0-7 7" />
              <path d="M3 19h11a7 7 0 0 0 7-7" />
            </svg>

            ${this.activatorLabel}
          </span>
        </summary>
        <div class="skio-details--content">
          ${this.renderDrawerContent()}
          <div class="skio-details--footer">
            <a class="skio-manage-link" href="/a/account/login"
              >Manage subscriptions</a
            >

            <a
              style="letter-spacing: 0"
              class="powered-by-skio"
              href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover"
              target="_blank"
              rel="noopener"
            >
              Powered by
              <svg
                width="24"
                height="11"
                viewBox="0 0 24 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z"
                  fill="black"
                />
                <path
                  d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z"
                  fill="black"
                />
                <path
                  d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z"
                  fill="black"
                />
                <path
                  d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </details>
    `}render(){var e,t,i,s,o,l,r,h,g,a,p,m,f;return!this.viable()||((e=this.options)==null?void 0:e.layout)==="hidden"?this.debug?this.setupMode():"":this.selectedVariant.selling_plan_allocations.length===0&&!((t=this.options)!=null&&t.show_without_subscription)?this.debug?this.setupMode():"":d`
      ${this.debug?this.setupMode():null}

      <fieldset
        class="skio-plan-picker"
        role="radiogroup"
        aria-labelledby="skio-plan-picker-legend"
      >
        <legend
          id="skio-plan-picker-legend"
          class="${(i=this.options)!=null&&i.show_legend?"":"sr-only"}"
        >
          ${x((s=this.options)==null?void 0:s.legend_content)}
        </legend>

        ${this.product.requires_selling_plan?"":d`
              <div
                class="group-container ${this.selectedSellingPlanGroup==null?"group-container--selected":""} ${(o=this.options)!=null&&o.onetime_first?"":"group-container--last"}"
                @click=${()=>this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One time purchase"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${()=>this.selectSellingPlanGroup(null)}
                />

                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${((l=this.options)==null?void 0:l.layout)=="horizontal"?"":(r=this.options)!=null&&r.show_radio_selector?this.radioTemplate():""}

                    <div class="group-title">
                      ${(h=this.options)!=null&&h.onetime_title?(g=this.options)==null?void 0:g.onetime_title:"One time purchase"}
                    </div>

                    <div class="skio-price" aria-live="polite">
                      ${(a=this.options)!=null&&a.show_compare_price&&((p=this.selectedVariant)==null?void 0:p.compare_at_price)>this.selectedVariant.price?d`<s aria-hidden="true"
                            >${this.money(this.selectedVariant.compare_at_price)}</s
                          >`:""}
                      ${this.money(this.selectedVariant.price)}
                    </div>
                  </div>
                </label>
              </div>
            `}
        ${(m=this.availableSellingPlanGroups)!=null&&m.length?this.availableSellingPlanGroups.map((c,y)=>{var v,u,k,w,S,P,$,E,L,q,M,T,I;return d`
                <div
                  class="group-container ${this.selectedSellingPlanGroup==c?"group-container--selected":""}"
                >
                  <input
                    id="group-${y}-${this.key}"
                    class="group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${c.id}"
                    @change=${()=>this.selectSellingPlanGroup(c)}
                    ?checked=${this.selectedSellingPlanGroup==c}
                  />

                  <label class="group-label" for="group-${y}-${this.key}">
                    <div class="group-topline">
                      ${((v=this.options)==null?void 0:v.layout)=="horizontal"?"":(u=this.options)!=null&&u.show_radio_selector?this.radioTemplate():""}

                      <div class="group-title">
                        ${c.name!=="Prepaid"&&((k=this.options)!=null&&k.subscription_title)?(w=this.options)==null?void 0:w.subscription_title:c.name=="Prepaid"&&((S=this.options)!=null&&S.prepaid_title)?(P=this.options)==null?void 0:P.prepaid_title:c.name}
                        ${this.discountText(c.selected_selling_plan)?d`
                              <span
                                class="savings ${($=this.options)==null?void 0:$.discount_style}"
                              >
                                ${this.discountText(c.selected_selling_plan)}
                              </span>
                            `:d``}
                      </div>

                      <div class="skio-price" aria-live="polite">
                        ${(E=this.options)!=null&&E.show_compare_price&&(((L=this.selectedVariant)==null?void 0:L.compare_at_price)>this.selectedVariant.price||this.selectedVariant.price>this.price(c.selected_selling_plan,!1))?d`<s aria-hidden="true"
                              >${this.money(this.selectedVariant.compare_at_price?this.selectedVariant.compare_at_price:this.selectedVariant.price)}</s
                            >`:""}
                        ${this.price(c.selected_selling_plan)}
                        ${this.postCheckoutDiscountsText(c.selected_selling_plan)}
                      </div>
                    </div>

                    ${((q=this.options)==null?void 0:q.layout)=="vertical"&&((M=this.options)==null?void 0:M.dropdownPosition)=="inside"?this.groupContent(c):""}
                  </label>
                </div>
                ${this.selectedSellingPlanGroup==c&&(((T=this.options)==null?void 0:T.layout)=="horizontal"||((I=this.options)==null?void 0:I.dropdownPosition)=="underneath")?this.groupContent(c):""}
              `}):""}
        ${((f=this.options)==null?void 0:f.show_details)==!0?this.showDetails():""}
      </fieldset>
    `}async fetchRules(){var e;if(sessionStorage.getItem("skio-discount-rules"))return JSON.parse(sessionStorage.getItem("skio-discount-rules"));{const t=await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${(e=window==null?void 0:window.Shopify)==null?void 0:e.shop}`).then(i=>i.json()).then(i=>i.rules.filter(s=>s.type!=="surpriseDelight").sort((s,o)=>s.minQuantityToDiscount-o.minQuantityToDiscount));return sessionStorage.setItem("skio-discount-rules",JSON.stringify(t)),t}}eligibleItemCount(e){var i,s;return(i=this.cart)!=null&&i.items?Number((s=this.cart)==null?void 0:s.items.reduce((o,l)=>e!=null&&e.productVariantIds.some(r=>r.includes(l.id)&&l.selling_plan_allocation)?o+l.quantity:o,0))+this.quantity:this.quantity}getRule(){let e={value:-1,index:-1};this.rules.forEach((t,i)=>{t.code&&e.value<t.minQuantityToDiscount&&t.minQuantityToDiscount<=this.eligibleItemCount(t)&&(e.value=t.minQuantityToDiscount,e.index=i)}),this.rule=e.index>-1?this.rules[e.index]:null}bindCartEvents(){document.addEventListener("CartUpdated",e=>{this.cart=e.detail})}bindFormEvents(){var e;this.form=document.querySelector(`#${(e=this.options)==null?void 0:e.form_id}`)||this.closest('form[action*="/cart/add"]'),this.form&&(this.variantInput=this.form.querySelector('[name*="id"]'),this.variantInput&&this.variantInput.addEventListener("change",t=>{this.selectedVariant=this.product.variants.find(i=>i.id==t.target.value),this.variantChanged=!0}))}detailsMouseover(){let e=this.renderRoot.querySelector(".skio-details"),t=this.renderRoot.querySelector(".skio-details summary");!e.hasAttribute("open")&&this.showDetailsHover==!1&&(t.click(),this.showDetailsHover=!0)}detailsMouseleave(){let e=this.renderRoot.querySelector(".skio-details"),t=this.renderRoot.querySelector(".skio-details summary");e.hasAttribute("open")&&this.showDetailsHover==!0&&(t.click(),this.showDetailsHover=!1)}updated(e){var t,i,s,o,l;if(this.viable()){if(e.has("product")&&this.product&&(this.key=this.key?this.key:this.product.id),e.has("selectedVariant")&&this.selectedVariant){const r=this.product.selling_plan_groups.filter(h=>h.app_id==="SKIO"&&!h.name.toLowerCase().includes("hidden-")&&!h.name.toLowerCase().includes("dynamic box subscription"));if(this.availableSellingPlanGroups=r.filter(h=>h.selling_plans.some(g=>this.selectedVariant.selling_plan_allocations.some(a=>a.selling_plan_id===g.id))),(t=this.options)!=null&&t.combine_groups&&(this.availableSellingPlanGroups=[{name:(i=this.options)==null?void 0:i.combined_group_name,selling_plans:this.availableSellingPlanGroups.flatMap(h=>h.selling_plans),id:"combined_group",app_id:"SKIO"}]),(s=this.availableSellingPlanGroups)!=null&&s.length){const g=new URL(window.location.href).searchParams.get("selling_plan");if(this.availableSellingPlanGroups.forEach(a=>{var v;const p=this.getAvailableSellingPlans(a),m=p.find(u=>u.id==g),f=p.find(u=>{var k;return u.name===((k=this.selectedSellingPlan)==null?void 0:k.name)}),c=(v=this.options)!=null&&v.default_subscription&&this.options.default_subscription.trim()!==""?p.find(u=>u.name.toLowerCase().includes(this.options.default_subscription.toLowerCase())):null;a.selected_selling_plan=m||f||c||p[0];const y=m||f||c;a.selected=!!y}),!this.variantChanged&&((o=this.options)==null?void 0:o.start_onetime)==!1||this.product.requires_selling_plan==!0||g||this.selectedSellingPlan){let p=(this.availableSellingPlanGroups.find(m=>m.selected)||this.availableSellingPlanGroups[0]).selected_selling_plan.id;this.selectSellingPlan(p)}else this.selectSellingPlanGroup(null)}else this.selectSellingPlanGroup(null)}if(e.has("selectedSellingPlan")){this.selectedSellingPlan?this.updateLineItemProperty(!0):this.updateLineItemProperty(!1);const r=new CustomEvent("skio::update-selling-plan",{bubbles:!0,composed:!0,detail:{variant:this.selectedVariant,sellingPlan:this.selectedSellingPlan,key:this.key}});this.dispatchEvent(r),this.dispatchEvent(new CustomEvent("change",{detail:{value:(l=this.selectedSellingPlan)==null?void 0:l.id}}))}this.updateForm(),this.updateExternalPrice(),this.disableUrl||this.updateURLParams(),e.has("quantity")&&this.getRule(),e.has("cart")&&this.getRule(),this.updateExternalElements()}}updateLineItemProperty(e){const t=document.querySelector('input[name="properties[_is_subscription]"]');t&&(t.value=e)}updateExternalElements(){document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach(e=>{e.innerHTML=this.price(this.selectedSellingPlan)}),document.querySelectorAll("[skio-subscription-content]").forEach(e=>{e.style.display=this.selectedSellingPlan?"block":"none"})}log(...e){e.unshift(`%c[skio plan picker][${this.key}]`,"color: #8770f2;"),console.log.apply(console,e)}error(...e){e.unshift(`%c [skio plan picker][${this.key}]`,"color: #ff0000"),console.error.apply(console,e)}appendOrdinalSuffix(e){const t=e%10,i=e%100;return t==1&&i!=11?e+"st":t==2&&i!=12?e+"nd":t==3&&i!=13?e+"rd":e+"th"}money(e){return this.moneyFormatter.format(e/100)}viable(){const e=[];return this.querySelector("input[name=selling_plan]")||e.push("Missing selling plan input"),this.product||e.push("No product found. Please pass a product or productHandle to the skio-plan-picker component."),this.selectedVariant||e.push("No variant found. Please pass a product or productHandle to the skio-plan-picker component."),this.form||e.push('No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".'),this.variantInput||e.push('No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"'),e.length==0?!0:(this.error("Errors",e),!1)}getAvailableSellingPlans(e){return e.selling_plans.filter(i=>this.selectedVariant.selling_plan_allocations.some(s=>s.selling_plan_id===i.id))}selectSellingPlanGroup(e){this.selectedSellingPlanGroup=e,this.selectedSellingPlan=e==null?void 0:e.selected_selling_plan}selectSellingPlan(e){const t=this.availableSellingPlanGroups.find(s=>s.selling_plans.some(o=>o.id==e)),i=t.selling_plans.find(s=>s.id==e);t.selected_selling_plan=i,this.selectedSellingPlanGroup=t,this.selectedSellingPlan=i}updateExternalPrice(){var e,t;document.querySelectorAll((e=this.options)==null?void 0:e.external_price_selector).forEach(i=>{this.selectedSellingPlan?i.innerHTML=this.price(this.selectedSellingPlan):i.innerHTML=this.money(this.selectedVariant.price)}),document.querySelectorAll((t=this.options)==null?void 0:t.external_price_selector).forEach(i=>{this.selectedSellingPlan?i.innerHTML=this.price(this.selectedSellingPlan)+" "+this.currency:i.innerHTML=this.money(this.selectedVariant.price)+" "+this.currency})}additionalFrequencyLabel(){var e,t,i;if(!(!((e=this.options)!=null&&e.additional_frequency_label)||((t=this.options)==null?void 0:t.additional_frequency_label)==""))return x((i=this.options)==null?void 0:i.additional_frequency_label)}additionalContentText(){var e,t,i,s;if(!(!((e=this.options)!=null&&e.additional_subscription_content)||((t=this.options)==null?void 0:t.additional_subscription_content)==""))return x((s=this.options)==null?void 0:s.additional_subscription_content.replaceAll("[discount]",((i=this.options)==null?void 0:i.discount_format)==="absolute"?this.money(this.discount(this.selectedSellingPlan).absolute):this.discount(this.selectedSellingPlan).percent+"%").replaceAll("[future_price_adjustments]",this.postCheckoutDiscountsText(this.selectedSellingPlan)||""))}discountText(e){var s,o,l;const t=this.discount(e);return Object.values(t).some(r=>r===0||r===1/0||r.toString().includes("-"))?"":(console.log("OPTIONS",this.options),console.log("DISCOUNT TEXT",(s=this.options)==null?void 0:s.discount_text),x((l=this.options)==null?void 0:l.discount_text.replaceAll("[discount]",((o=this.options)==null?void 0:o.discount_format)==="absolute"?this.money(t.absolute):t.percent+"%").replaceAll("[future_price_adjustments]",this.postCheckoutDiscountsText(e)||"")))}discount(e){return e?this.getDiscountFromPriceAdjustment(e,e.price_adjustments[0]):{percent:0,amount:0}}postCheckoutPriceAdjustments(e){const{price_adjustments:t}=e;return t.filter(({position:o})=>o!==1).map(o=>this.getDiscountFromPriceAdjustment(e,o))}postCheckoutDiscountsText(e=this.selectedSellingPlan){var i;if(!e||!((i=this.options)!=null&&i.future_price_adjustments_text)||this.future_price_adjustments_text=="")return;const t=this.postCheckoutPriceAdjustments(e);if(t.length)return t.map((s,o)=>{var l,r;return x((r=this.options)==null?void 0:r.future_price_adjustments_text.replaceAll("[price]",this.money(Math.round(this.price(e,!1)-s.amount))).replaceAll("[discount]",((l=this.options)==null?void 0:l.discount_format)==="absolute"?this.money(s.absolute):s.percent+"%").replaceAll("[order_count]",o+1).replaceAll("[order_count_ordinal]",this.appendOrdinalSuffix(o+1)))})}getDiscountFromPriceAdjustment(e,t){const i={percent:0,amount:0,absolute:0};let s=1,o=this.product.selling_plan_groups.find(h=>h.selling_plans.some(g=>g.id==e.id));if((o==null?void 0:o.name)==="Prepaid"){const h=e.name,g=/\b\d+\s*(days|weeks|months|years)\b/gi,a=h.match(g);if(a!=null&&a.length){const p=a[0].match(/\d+/g);s=p[0]/(p[1]||1),s=s>1?s:1}}const l=this.selectedVariant.price,r=this.selectedVariant.compare_at_price&&this.selectedVariant.compare_at_price>l?this.selectedVariant.compare_at_price:l;switch(t.value_type){case"percentage":i.percent=t.value,i.absolute=Math.round(l*t.value/100),i.amount=Math.round(l*t.value/100);break;case"fixed_amount":i.percent=Math.round(t.value*1/l*100),i.absolute=t.value,i.amount=t.value;break;case"price":i.percent=Math.round((r*s-t.value)*1/(r*s)*100),i.absolute=r*s-t.value,i.amount=l-t.value;break}return i}price(e,t=!0){return this.rule?t?this.money(this.selectedVariant.price-this.discount(e).amount-this.selectedVariant.price*(this.rule.discountAmount/100)):this.selectedVariant.price-this.discount(e).amount-this.selectedVariant.price*(this.rule.discountAmount/100):t?this.money(this.selectedVariant.price-this.discount(e).amount):this.selectedVariant.price-this.discount(e).amount}updateForm(){let e=this.querySelector("input[name=selling_plan]");e&&(e.value=this.selectedSellingPlan?this.selectedSellingPlan.id:"",e.dispatchEvent(new Event("change")))}updateURLParams(){const e=new URL(window.location.href);this.selectedSellingPlan?(e.searchParams.set("selling_plan",this.selectedSellingPlan.id),window.history.replaceState({},"",e.href)):(e.searchParams.delete("selling_plan"),window.history.replaceState({},"",e.href))}addToCart(e){var i;const t=[{id:this.selectedVariant.id,quantity:e,...this.selectedSellingPlan&&{selling_plan:(i=this.selectedSellingPlan)==null?void 0:i.id}}];fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:t})}).then(s=>s.json()).then(s=>{this.log("Added item to cart: ",s);const o=new CustomEvent("skio::added-to-cart",{bubbles:!0,composed:!0,detail:{response:s,key:this.key}});this.dispatchEvent(o)}).catch(s=>{this.error(`SKIO ${this.key} error adding item to cart: `,s)})}}_(C,"properties",{key:{type:String},product:{type:Object},productHandle:{type:String},selectedVariant:{type:Object},options:{type:Object},quantity:{type:Number},rules:{type:Array},rule:{type:Object},cart:{type:Object},availableSellingPlanGroups:{state:!0},selectedSellingPlanGroup:{type:Object},selectedSellingPlan:{type:Object},disableUrl:{type:Boolean},debug:{type:Boolean},activatorLabel:{type:String},subscriptionTooltipText:{type:String}}),_(C,"styles",[A`
      :host {
        width: 100%;
        max-width: 440px;
      }

      .skio-plan-picker {
        display: flex;
        gap: 0.5rem;
        padding: 0;
        border: 0;
        font-size: 12px;
        color: black;
        width: 100%;
        margin-bottom: 1rem;
        font-family: inherit;
      }

      :host([layout="hidden"]) .skio-plan-picker {
        display: none;
      }

      :host([layout="vertical"]) .skio-plan-picker {
        flex-direction: column;
      }

      :host([layout="horizontal"]) .skio-plan-picker {
        flex-direction: row;
        flex-wrap: wrap;
      }

      .sr-only {
        position: absolute;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
      }

      .group-container {
        display: block;
        position: relative;
        transition: border-color 0.2s ease;
        border: var(--skio-group-border-width, 1px) solid
          var(--skio-group-border-color, #ccc);
        border-radius: var(--skio-group-border-radius, 0);
        background-color: var(--skio-group-background-color, transparent);
        color: var(--skio-group-text-color, #000);
      }

      .group-container--selected {
        border-color: var(--skio-group-border-selected-color, #333);
        background-color: var(
          --skio-group-background-selected-color,
          transparent
        );
        color: var(--skio-group-text-selected-color, #000);
      }

      .group-container--last {
        order: 1;
      }

      :host([layout="horizontal"]) .group-container {
        width: calc(
          50% - 0.5rem - calc(2 * var(--skio-group-border-width, 1px))
        );
      }

      .group-input {
        position: absolute;
        opacity: 0;
        width: 0px;
        height: 0px;
      }

      .group-input:focus-visible ~ .group-label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .group-label {
        display: flex;
        flex-direction: column;
        padding: 10px;
        cursor: pointer;
      }

      .group-topline {
        display: flex;
        align-items: center;
        width: 100%;

        gap: 8px;
      }

      .group-container--selected .group-topline {
        font-weight: 700;
      }

      :host([layout="horizontal"]) .group-topline {
        flex-direction: column;
        text-align: center;
      }

      .skio-radio__container {
        display: flex;
        color: var(--skio-group-border-color, #333);
      }

      .group-container--selected .skio-radio__container {
        color: var(--skio-group-border-selected-color, #333);
      }

      .skio-radio {
        transform-origin: center;
        opacity: 0;
        transform: scale(0);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-label:hover .skio-radio {
        opacity: 0.75;
        transform: scale(1);
      }

      .group-container--selected .group-label .skio-radio {
        opacity: 1;
        transform: scale(1);
      }

      .skio-price {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        align-items: center;
        text-align: right;
        gap: 4px;

        line-height: 1;

        margin-left: auto;
        vertical-align: middle;

        font-weight: 500;
      }

      .skio-price s {
        font-size: 13px;

        font-weight: 400;
        opacity: 0.75;
      }

      :host([layout="horizontal"]) .skio-price {
        text-align: center;
        margin-right: auto;
      }

      .group-content {
        display: flex;
        flex-direction: column;
        opacity: 1;
        width: auto;
        max-height: 1000px;
        transition:
          max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1),
          opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-content.margin-left {
        margin-left: 25px;
      }

      .group-content p {
        margin: 0.5rem 0 0 0;
        font-size: 13px;
        color: #000;
      }

      :host([layout="horizontal"]) .group-content {
        width: 100%;
      }

      /* Hide frequency if not selected */
      .group-container:not(.group-container--selected) .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      :host([layout="horizontal"])
        .group-container:not(.group-container--selected)
        + .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      .group-title {
        width: 100%;
        max-width: 80%;
        line-height: 1.5;
      }

      :host([layout="horizontal"]) .group-title {
        max-width: 100%;
      }

      .savings {
        color: var(--skio-discount-text-color, #fff);
      }

      .savings.bubble {
        padding: 0px 8px;
        background-color: var(--skio-discount-color, #0fa573);
        border: 1px var(--skio-discount-color, #0fa573) solid;
        border-radius: 4px;
        font-size: 10px;
        color: var(--skio-discount-text-color, #fff);

        white-space: nowrap;
      }

      .selling-plan-dropdown {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        margin-top: 5px;
        padding: 8px 30px 8px 10px;
        background-color: #f7f7f7;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px top 50%;
        background-size: 16px;
        border: 1px solid #ccc;
        border-radius: 2px;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .selling-plan-dropdown-label {
        color: #666666;
        font-weight: 500;
      }

      .selling-plan-dropdown--one {
        background-image: none;
        pointer-events: none;
        background: transparent;
      }

      .selling-plan-buttons {
        display: grid;
        grid-template-columns: repeat(
          auto-fill,
          minmax(var(--skio-button-plan-selector-width, 20px), 1fr)
        );
        gap: 10px;
        padding: 0.75rem 0;
        border: 0;
        font-size: 13px;
      }

      .selling-plan-buttons input[type="radio"] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .selling-plan-buttons label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #ccc;
        text-align: center;
        padding: 1rem 0.5rem;
      }

      .selling-plan-buttons input[type="radio"]:checked + label {
        border-color: #000;
      }

      .selling-plan-buttons input:focus-visible + label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .skio-details {
        --text-color: #333;
        --text-color-secondary: #888;

        user-select: none;
        -webkit-user-select: none;
        margin-bottom: 20px;
        order: 3;
        max-width: max-content;
      }

      .skio-details summary::-webkit-details-marker,
      .skio-details summary::marker,
      .skio-details slot {
        color: rgba(0, 0, 0, 0) !important;
      }

      .skio-details summary {
        margin-top: 15px;
      }

      .skio-details summary span {
        font-size: 0.9em;
        display: flex;
        padding: 0.5em 0;
        cursor: pointer;
        align-items: center;
        gap: 10px;
        text-decoration: underline;

        margin-top: -40px;
        color: #000;
      }

      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-15px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
      .skio-details[open] > .skio-details--content {
        animation-name: fadeInDown;
        animation-duration: 0.3s;
      }

      .skio-details--content {
        position: absolute;
        z-index: 1020;
        padding: 1em;
        width: fit-content;
        border-radius: 5px;
        background: white;
        box-shadow:
          0 0 5px rgb(23 24 24 / 5%),
          0 1px 2px rgb(0 0 0 / 7%);
      }

      .skio-details ul {
        margin: 0;
        padding: 0;
      }

      .skio-details ul li {
        display: flex;
        align-items: flex-start;
        gap: 0.75em;

        margin-bottom: 1em;
      }

      .skio-details .skio-content {
        display: flex;
        flex-direction: column;
      }

      .skio-details .skio-content p {
        font-size: 0.9em;

        margin-top: 0;
        margin-bottom: 0;

        letter-spacing: 0;
        line-height: 1.5;

        color: var(--text-color);
      }

      .skio-details ul li small {
        font-size: 0.7em;
        color: var(--text-color-secondary);
      }

      .skio-details .skio-icon {
        display: flex;

        width: 2.25em;
        height: 2.25em;

        color: var(--text-color);
        background: #f8f8f8;
        border-radius: 100%;

        flex-shrink: 0;
        align-items: center;
        justify-content: center;
      }

      .skio-details .skio-icon svg {
        width: 1.25em;
        height: 1.25em;

        color: inherit;
      }

      .skio-details--footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.9em;
      }

      .skio-details--footer a {
        color: var(--text-color);
      }

      .skio-manage-link {
        text-decoration: underline;
      }

      .powered-by-skio {
        font-size: 0.8em;

        display: flex;
        text-decoration: none;

        align-items: center;
        gap: 3px;
      }

      .setupMode {
        position: relative;
        color: black;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 1rem;
        font-size: 14px;
        border-style: solid;
        border-width: 4px;
        border-image: repeating-linear-gradient(
            -55deg,
            #000,
            #000 20px,
            #ffb101 20px,
            #ffb101 40px
          )
          10;
      }

      .setupMode:after {
        content: "Setup Mode";
        position: absolute;
        top: 0;
        right: 0;
        background-color: black;
        color: white;
        padding: 0.25rem 1rem;
        font-size: 13px;
      }

      .setupMode .detection {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 10px;
      }

      .setupMode .detection small {
        grid-column: 1/-1;
      }

      #skio-plan-picker-legend {
        margin-block-end: var(--spacing-s);
        display: block;
        color: var(--color-black);
        font-weight: var(--weight-semi);
        font-family: var(--title-font);
        font-size: var(--font-size-m);
      }
    `]);customElements.get("skio-plan-picker")||customElements.define("skio-plan-picker",C);window&&(window.SkioPlanPicker=C);class H extends HTMLElement{constructor(){super(),this.productHandle=this.getAttribute("product-handle")||"",this.trigger=null,this.dialog=null}connectedCallback(){this.setupQuickshop(),document.addEventListener("quickshop:loaded",()=>{window.setTimeout(()=>{var n;(n=document.querySelector(".quickshop-content"))==null||n.classList.remove("form-loading")},1e3)})}disconnectedCallback(){this.cleanup()}setupQuickshop(){if(this.trigger=this.querySelector("[data-quickshop-trigger]"),!this.trigger){console.warn("Quickshop trigger button not found");return}this.trigger.addEventListener("click",this.openQuickshop.bind(this))}cleanup(){if(this.trigger&&this.trigger.removeEventListener("click",this.openQuickshop.bind(this)),this.dialog){const n=this.dialog.querySelector(".quickshop-close");n==null||n.removeEventListener("click",this.closeQuickshop.bind(this)),this.dialog.removeEventListener("click",this.handleBackdropClick.bind(this)),this.dialog.removeEventListener("keydown",this.handleKeydown.bind(this)),this.dialog.remove(),this.dialog=null}}createDialog(){this.dialog=document.createElement("dialog"),this.dialog.className="quickshop-dialog",this.dialog.setAttribute("aria-modal","true"),this.dialog.setAttribute("role","dialog");const n=document.createElement("div");n.className="quickshop-header";const e=document.createElement("h2");e.className="quickshop-header__title",e.textContent="Quickshop",n.appendChild(e);const t=document.createElement("button");t.className="quickshop-close",t.setAttribute("aria-label","Close quickshop"),t.innerHTML=`
        <svg class="quickshop-close__icon" width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="1.25192" y1="12.6464" x2="13.2519" y2="0.646454" stroke="currentColor"/>
          <line x1="1.35355" y1="0.646447" x2="13.3535" y2="12.6464" stroke="currentColor"/>
        </svg>
      `,n.appendChild(t),this.dialog.appendChild(n);const i=document.createElement("div");i.className="quickshop-content",this.dialog.appendChild(i),document.body.appendChild(this.dialog),t.addEventListener("click",this.closeQuickshop.bind(this)),this.dialog.addEventListener("click",this.handleBackdropClick.bind(this)),this.dialog.addEventListener("keydown",this.handleKeydown.bind(this)),this.dispatchEvent(new CustomEvent("quickshop:open",{bubbles:!0,composed:!0})),document.addEventListener("cart:updated",()=>{this.closeQuickshop()})}async openQuickshop(){var e,t,i,s,o;const n=this.getAttribute("product-handle");if(n){this.dialog||this.createDialog(),document.body.classList.add("no-scroll"),(e=document.querySelector("html"))==null||e.classList.add("no-scroll");try{this.setContent('<div class="loading">Loading...</div>'),this.dialog&&(this.dialog.showModal(),requestAnimationFrame(()=>{var k,w;(k=this.dialog)==null||k.classList.remove("is-closing"),(w=this.dialog)==null||w.classList.add("is-open")})),(i=(t=this.dialog)==null?void 0:t.querySelector(".quickshop-content"))==null||i.classList.add("form-loading");const l=await fetch(`/products/${n}`);if(!l.ok)throw new Error("Failed to load quickshop content");const r=await l.text(),a=new DOMParser().parseFromString(r,"text/html").getElementById("product");if(!a)throw new Error("Product section not found");(s=a.querySelector("uwp-product-media-slider"))==null||s.remove(),(o=a.querySelector(".product-details__reviews-container"))==null||o.remove();const p=document.createElement("a");p.href=`/products/${n}`,p.textContent="View product details",p.className="quickshop__view-details btn--secondary-link btn";const m=document.createElement("div");m.className="quickshop__view-details-container",m.appendChild(p);const f=a.querySelector(".product__footer");f==null||f.appendChild(m);const c=a.querySelector(".product__media"),y=c?c.innerHTML:"",v=document.createElement("div");v.className="quickshop__mobile-media product__media",v.innerHTML=y;const u=a.querySelector(".product-details__title-info");u==null||u.insertBefore(v,u.firstChild||null),this.setContent(a.outerHTML),await this.initializeQuickshopContent(),this.dispatchEvent(new CustomEvent("quickshop:loaded",{bubbles:!0,composed:!0}))}catch(l){console.error("Error loading quickshop:",l),this.setContent('<div class="error">Sorry, there was an error loading the product. Please try again.</div>')}}}destroyQuickshop(){this.dialog&&(this.dialog.remove(),this.dialog=null)}closeQuickshop(){var e;if(!this.dialog)return;document.body.classList.remove("no-scroll"),(e=document.querySelector("html"))==null||e.classList.remove("no-scroll"),this.dialog.classList.remove("is-open"),this.dialog.classList.remove("is-closing");const n=t=>{var i,s,o,l;t.target===this.dialog&&t.propertyName==="transform"&&((i=this.dialog)==null||i.removeEventListener("transitionend",n),(s=this.dialog)==null||s.close(),(o=this.dialog)==null||o.remove(),this.dialog=null,(l=this.trigger)==null||l.focus())};this.destroyQuickshop(),this.dialog.addEventListener("transitionend",n)}handleBackdropClick(n){n.target===this.dialog&&this.closeQuickshop()}handleKeydown(n){n.key==="Escape"&&this.closeQuickshop()}setContent(n){var t;const e=(t=this.dialog)==null?void 0:t.querySelector(".quickshop-content");e&&(e.innerHTML=n)}async initializeQuickshopContent(){var t;const n=(t=this.dialog)==null?void 0:t.querySelector(".quickshop-content");if(!n)return;"customElements"in window&&await customElements.whenDefined("uwp-product-swatches");const e=n.querySelector("uwp-product-swatches");e&&(e.isConnected||(document.body.appendChild(e),e.remove()))}}customElements.define("uwp-quickshop",H);
